<template>
  <div>
    <v-card dark color="cyan darken-4">
      <v-card-title class="black green--text mx-auto text-center" primary-title>
        {{selTable.toUpperCase()}}
        <v-spacer></v-spacer>
        <v-btn x-small dark rounded color="red darken-4">
          <v-icon @click="$emit('close-dialog')">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mx-auto">
        <table>
          <thead>
            <tr>
              <th
                v-for="(header,hid) in tblHeaders"
                :key="hid+Math.random()+Math.random()"
              >{{header}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row ,isd) in selData" :key="isd+Math.random()+Math.random()+Math.random()">
              <td
                v-for="(hdr,hic) in tblHeaders"
                :key="hic+Math.random()+Math.random()+Math.random()+Math.random()"
              >
                <input v-if="hdr.includes('date')" type="date" @change="saveChanges(row['id'],hdr)" />
                <input
                  v-else-if="hdr.includes('color')"
                  type="color"
                  @change="saveChanges(row['id'],hdr)"
                />
                <v-select
                  v-else-if="hdr.includes('_id') && hdr.endsWith('_id')"
                  dark
                  color="cyan darken-4"
                  :items="dropdownItems[hdr]"
                  item-text="name"
                  item-value="id"
                  :label="row[hdr]"
                  @change="saveChanges(row['id'],hdr)"
                ></v-select>
                <v-textarea v-else rows="1" :value="row[hdr]" @change="saveChanges(row['id'],hdr)"></v-textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  props: ["selTable", "tblHeaders", "selData", "dropdownItems"],

  data() {
    return {
      colData: "kenneth",
      selectItems: [1, 2, 3, 4],
      colId: null
    };
  },
  methods: {
    saveChanges(id, column) {
      const value = event.target.value;
      const table = this.selTable;
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: table, id: id, column: column, value: value },
          this.getAccessToken
        )
        .then(response => {
          const useless = response;
        });
    }
  },
  filters: {
    catifyHead(value) {
      if (value.includes("_")) {
        const spArr = value.split("_");

        let newStr = "";
        for (let i = 0; i < spArr.length; i++) {
          newStr += spArr[i].toUpperCase() + " ";
        }
        return newStr;
      } else {
        const newStr = value.toUpperCase();
        return newStr;
      }
    }
  }
};
</script>

<style>
</style>